import { makeSelectors } from '@utils/css';

const tooltip = "dibttcmgcd";
const arrow = "diba1il7ggb";
const label = "dibla28vq3";
const shortcut = "dibsedmzpd";
const tooltipSelectors = makeSelectors({
  label,
  arrow,
  shortcut
});

export { arrow, label, shortcut, tooltip, tooltipSelectors };
import "./tooltip.styles.linaria.module.css";
//# sourceMappingURL=tooltip.styles.js.map
